export default "__VITE_ASSET__CLQK5jhj__"